import { escapeCsvCell } from "./csvFileHelpers";
import { isPlaceholderEmail } from "./displayEmail";
import { formatPhoneDisplay } from "./phoneFormat";
import {
  PARTICIPANT_PROFILE_DETAILS_TABLE_COLUMNS,
  formatParticipantProfileName,
  getParticipantProfileDetailsDisplay,
} from "./participantProfileDetailsDisplay";

/** CSV header labels in table-column order (full report, not only visible columns). */
export const PARTICIPANT_PROFILE_DETAILS_CSV_HEADER_LABELS =
  PARTICIPANT_PROFILE_DETAILS_TABLE_COLUMNS.map((c) => c.label);

export const PARTICIPANT_PROFILE_DETAILS_CSV_HEADER_LINE =
  PARTICIPANT_PROFILE_DETAILS_CSV_HEADER_LABELS.join(",");

function csvEmailCell(raw) {
  const s = raw != null ? String(raw).trim() : "";
  return s && !isPlaceholderEmail(s) ? s : "";
}

function csvPhoneCell(raw) {
  return raw != null && String(raw).trim() ? formatPhoneDisplay(raw) : "";
}

/** @param {Record<string, unknown>} row */
export function participantProfileDetailsRowToCsvCells(row) {
  return PARTICIPANT_PROFILE_DETAILS_TABLE_COLUMNS.map((col) => {
    switch (col.id) {
      case "participant":
        return formatParticipantProfileName(row) === "—" ? "" : formatParticipantProfileName(row);
      case "email":
        return csvEmailCell(row?.email);
      case "phone":
        return csvPhoneCell(row?.phone);
      case "parent_email":
        return csvEmailCell(row?.parent_email);
      case "parent_phone":
        return csvPhoneCell(row?.parent_phone);
      default: {
        const display = getParticipantProfileDetailsDisplay(row, col.id);
        return display === "—" ? "" : display;
      }
    }
  });
}

/**
 * @param {Record<string, unknown>[]} rows
 * @returns {string}
 */
export function buildParticipantProfileDetailsCsvExportText(rows) {
  const list = Array.isArray(rows) ? rows : [];
  const lines = [
    PARTICIPANT_PROFILE_DETAILS_CSV_HEADER_LINE,
    ...list.map((row) =>
      participantProfileDetailsRowToCsvCells(row).map(escapeCsvCell).join(",")
    ),
  ];
  return lines.join("\r\n");
}
